/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 46,
  image: "default-changelog-v2.png",
  title: "Sign up with Ethereum, Astro & Vuepress Support, Various Compute Improvements",
  shortDescription: "We have released a new version of the Spheron Platform, which includes some new Features like Web3 Auth and creating an account using a Ethereum wallet, Astro & Vurepress support, and various Compute Improvements.",
  description: "We have released a new version of the Spheron Platform, which includes some new Features like Web3 Auth and creating an account using a Ethereum wallet, Astro & Vurepress support, and various Compute Improvements.",
  date: "Oct 2nd, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron"]
};
export const content = `
## Introducing Sign in with Ethereum 🌐

We're thrilled to introduce our latest feature: "Sign in with Ethereum". At Spheron we constantly strive to streamline user experience while prioritizing security. Here's what's new:

- **Ethereum Wallet Integration:** Users can now easily sign up and log in by connecting their Ethereum wallet. Connect and sign, it's that simple!
- **Wide Compatibility:** Whether you use Metamask, Rainbow, Wallet Connect, or any other major Ethereum wallet app, we've got you covered. Our platform seamlessly integrates with these wallets, offering you a smooth and intuitive sign-in experience.
- **Swift and Seamless:** With just a few taps, connect your wallet and authenticate by simply signing a message. We've minimized the friction, making the process quick and hassle-free.
- **Security First:** Your security is paramount. The "Sign in with Ethereum" feature ensures that you can authenticate without compromising your private keys or security protocols. We never access your funds or sensitive data; you just sign a message, and you're in!
- **Full Access to Spheron Services:** Once authenticated with Ethereum, users can effortlessly access all the incredible services offered by Spheron. Dive in and explore without any constraints.

Our team remains dedicated to continuous improvement and offering top-tier experiences to our users. Dive in and give "Sign in with Ethereum" a try!

## Platform Improvements & Fixes

- **Introducing New Frameworks for Static Site::** We’ve added support for two new frameworks, **Astro** and **Vuepress**.
- **Compute Improvements:**
  - **Enhanced Logs:** We've made significant improvements to deployment, instance, and shell logs, providing you with better visibility and control over your application's performance and troubleshooting.
  - **Custom Plan Selection:** We've resolved the issue where the correct custom plan wasn't being selected during instance updates.
  - **Instance Resource Monitoring:** Basic resource monitoring, including CPU and memory usage, is now available for On-Demand instances.
  - **UI Improvements:** We've fixed various UI glitches related to redeploying template instances, ensuring a smoother experience.
  - **Persistent Storage:** The persistent storage update flow has been fixed, making it more intuitive and reliable.
  - **Env Variable and Custom Storage:** We've resolved issues related to the update flow for environment variables and custom storage.
  - **Region and Scaling Type Updates:** Loading issues when updating region or scaling type have been fixed for a more seamless experience.
  - **General Enhancements:** We've addressed a range of issues and made numerous enhancements to ensure a smoother deployment process and an overall improved user experience.`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
